import { gql } from "@stadium/services/apollo-client";

export const fetchStoreAuthBasedParams = gql`
  query Store($number: String) {
    store(number: $number) {
      id
      designedStoreIds: storeIds
    }
  }
`;

export const fetchUserDesignedStoreConfig = gql`
  query fetchUserDesignedStoreConfig($includeCollectionDetails: Boolean! = false) {
    user {
      id
      lockerSwagList(type: "myself") {
        id: storeId
        name @include(if: $includeCollectionDetails)
        number @include(if: $includeCollectionDetails)
      }
      onDemandSwagList(type: "myself") {
        id: storeId
        name @include(if: $includeCollectionDetails)
        number @include(if: $includeCollectionDetails)
      }
      allLockerSwagList: lockerSwagList {
        id: storeId
        name @include(if: $includeCollectionDetails)
        number @include(if: $includeCollectionDetails)
      }
      allOnDemandSwagList: onDemandSwagList {
        id: storeId
        name @include(if: $includeCollectionDetails)
        number @include(if: $includeCollectionDetails)
      }
    }
  }
`;
